
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/export-frontend",
      function () {
        return require("private-next-pages/export-frontend/index.tsx");
      }
    ]);
  